import Vue from "vue"
import config from '../config'

export default {
    getContactById(contactId) {
        return Vue.http.get(config.apiBaseUrl + `/contacts/${contactId}`, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json()) 
    },

    createContact(body){
        return Vue.http.post(config.apiBaseUrl + '/contacts', body, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json())
    },

    setContactPhones(body, contactId) {
        return Vue.http.put(config.apiBaseUrl + `/contacts/${contactId}/contact-phones`, body, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json())
    },

    setContactAddresses(body, contactId) {
        return Vue.http.put(config.apiBaseUrl + `/contacts/${contactId}/contact-addresses`, body, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json())
    }, 

    updateContact(body, contactId) {
        return Vue.http.patch(config.apiBaseUrl + `/contacts/${contactId}`, body, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json())
    },

    getRequestHistory(contactId) {
        return Vue.http.get(config.apiBaseUrl + `/contacts/${contactId}/request-history`, { 
            headers: { 'Content-type': 'application/json' }
        }).then((response) => response.json()) 
    }
}
